import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-453d68d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ui middle aligned center aligned grid",
  id: "login-main",
  style: {"height":"100vh"}
}
const _hoisted_2 = {
  class: "column",
  style: {"max-width":"420px"}
}
const _hoisted_3 = { class: "ui raised segment" }
const _hoisted_4 = {
  key: 0,
  class: "ui error message"
}
const _hoisted_5 = {
  class: "ui black header",
  style: {"font-size":"1.5rem","font-weight":"600"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "google icon" }, null, -1))
const _hoisted_7 = {
  class: "ui horizontal divider",
  style: {"color":"#ccc"}
}
const _hoisted_8 = {
  class: "ui form segment",
  style: {"border-radius":"10px","padding":"15px","background-color":"#f0f0f0"}
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "ui left icon input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "envelope icon" }, null, -1))
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "ui left icon input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lock icon" }, null, -1))
const _hoisted_15 = { class: "ui large form" }
const _hoisted_16 = {
  class: "ui segment",
  style: {"border":"none","padding-top":"10px"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "cf-turnstile",
    "data-sitekey": "0x4AAAAAAAwqeJZqvEuGZj6H"
  })
], -1))
const _hoisted_18 = { class: "field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "ui dimmer modals visible active clickable",
    id: "login-bg",
    style: {"background":"rgba(0, 0, 0, 0.6)"},
    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleLogin()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isInApp)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "本系統不支援facebook, line等app內部瀏覽，請用一般瀏覽器開啟，方可登入，謝謝"))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('login.login_into_your_account')), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["ui fluid large button", {disabled: _ctx.isInApp}]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginGoogle && _ctx.loginGoogle(...args)), ["stop"])),
            style: {"background-color":"#4285F4 !important","color":"white"}
          }, [
            _hoisted_6,
            _createTextVNode(_toDisplayString(_ctx.$t('login.login_with_google')), 1)
          ], 2),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('login.or')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "email",
                  placeholder: "E-mail address",
                  style: {"font-size":"14px"},
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.users_email) = $event)),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                }, null, 512), [
                  [_vModelText, _ctx.users_email]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  name: "user_password",
                  placeholder: "Password",
                  style: {"font-size":"14px"},
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.user_password) = $event)),
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, null, 512), [
                  [_vModelText, _ctx.user_password]
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["ui fluid large button", {disabled: _ctx.isInApp}]),
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginWithEmail && _ctx.loginWithEmail(...args)), ["prevent"])),
              style: {"background-color":"#e47e10","color":"white","font-weight":"bold"}
            }, "登入", 2),
            _createElementVNode("a", {
              class: "small forgot-password",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)))
            }, _toDisplayString(_ctx.$t('login.forgot_password')), 1)
          ]),
          _createElementVNode("form", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", {
                  class: "ui checkbox",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.keeploggedin) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.keeploggedin]
                  ]),
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('login.keep_me_logged_in')), 1)
                ])
              ])
            ]),
            _createElementVNode("p", null, [
              _createTextVNode("新用戶？按此"),
              _createElementVNode("div", {
                class: _normalizeClass(["ui large basic button", {disabled: _ctx.isInApp}]),
                id: "register-btn",
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.registerWithEmail && _ctx.registerWithEmail(...args)), ["stop"]))
              }, "註冊", 2)
            ])
          ])
        ])
      ])
    ])
  ]))
}